import type { MyChallenge } from '@accra/shared';
import type { BadgeProgress } from '../../net/challenges';
import { el } from '../components/el';
import { Screen } from '../components/screen';
import { badgesView } from './badgesView';
import { challengesView } from './challengesView';

type Tab = 'badges' | 'challenges';

export interface MeLoaders {
  badges(): Promise<BadgeProgress | null>;
  challenges(): Promise<MyChallenge[] | null>;
  /** You've looked at your challenges: clears the "new" count. */
  seen(): void;
  copy(code: string): Promise<'copied' | 'failed'>;
}

/** One place for everything about you: your badges, and the challenges you've sent with who beat you. */
export class Me extends Screen {
  private readonly content = el('div', 'me-content');
  private readonly tabs = new Map<Tab, HTMLButtonElement>();

  constructor(parent: HTMLElement, private readonly loaders: MeLoaders, onClose: () => void) {
    super(parent, 'me side-panel');
    const head = el('div', 'garage-head');
    head.append(el('h2', '', 'Me'));
    const tabs = el('div', 'tabs');
    for (const [id, label] of [['badges', '🏅 Badges'], ['challenges', '📤 My challenges']] as const) {
      const button = el('button', 'tab', label);
      button.addEventListener('click', () => void this.open(id));
      this.tabs.set(id, button);
      tabs.append(button);
    }
    this.panel.append(head, tabs, this.content, this.button('Done', onClose, 'primary wide'));
  }

  async open(tab: Tab = 'badges'): Promise<void> {
    this.tabs.forEach((button, id) => button.classList.toggle('active', id === tab));
    this.content.replaceChildren(el('p', 'muted', 'Loading…'));
    this.show();
    if (tab === 'badges') {
      this.content.replaceChildren(badgesView(await this.loaders.badges()));
      return;
    }
    const challenges = await this.loaders.challenges();
    this.content.replaceChildren(challengesView(challenges, this.loaders.copy));
    this.loaders.seen();
  }
}
